import { render, staticRenderFns } from "./budget-program-filter.vue?vue&type=template&id=2b63de40&scoped=true&"
import script from "./budget-program-filter.vue?vue&type=script&lang=ts&"
export * from "./budget-program-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63de40",
  null
  
)

export default component.exports